import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const sendWelcomeEmailSlice = getBulkActionSlice(
    'sendWelcomeEmailResult',
);

export const selectSendWelcomeEmailShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.sendWelcomeEmailResult.shown;

export const selectSendWelcomeEmailBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.sendWelcomeEmailResult.uuid;

export const selectSendWelcomeEmailTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.sendWelcomeEmailResult.backgroundTask;


export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = sendWelcomeEmailSlice.actions;
